/* eslint-disable @typescript-eslint/no-explicit-any */
import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type CurrentUserTenantInvitationCodeAcceptSerializerType = {
  invitationCode: string;
  tenant: Record<string, any>;
};

export type PostCurrentUserTenantInvitationCodeAcceptPayloadType = (
  Pick<CurrentUserTenantInvitationCodeAcceptSerializerType, 'invitationCode'>
);
export type PostCurrentUserTenantInvitationCodeAcceptResponseType = (
  Pick<CurrentUserTenantInvitationCodeAcceptSerializerType, 'tenant'>
);

export const apiAcceptTenantInvitationCode = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostCurrentUserTenantInvitationCodeAcceptPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.currentUserTenantInvitationCodeAccept(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
